import React from 'react';
import { subscribeGallery, visibleCollectionKeys } from '../lib/gallery';
import { MOBILE_QUERY, currentDevice, observeDevice, observeLayout } from '../lib/layout';

// Welche Kategorien es gibt, entscheidet der Admin-Bereich. Leere Kategorien
// bleiben hier aussen vor — angelegt, aber noch ohne Bilder, haben sie auf der
// Website nichts verloren.
class Collections extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            // null heisst: noch nichts geladen, siehe landing.js.
            selectedmenu: null,
            mode: window.matchMedia(MOBILE_QUERY).matches ? 'mobile' : 'web',
            // Fuer die Spaltenzahl zaehlt die Geraeteklasse, nicht das Layout:
            // ein Tablet ist breit genug fuers Rechner-Layout, braucht aber
            // weniger Bilder nebeneinander.
            geraet: currentDevice(),
            datadict: null
        }
    }

    componentDidMount() {
        var that = this;
        this.disposeLayout = observeLayout(function (mode) {
            that.setState({ mode: mode });
        });
        this.disposeDevice = observeDevice(function (geraet) {
            that.setState({ geraet: geraet });
        });
        this.unsubscribe = subscribeGallery(function (gallery) {
            var sichtbar = visibleCollectionKeys(gallery.collections);
            // Die gewaehlte Kategorie kann inzwischen entfernt oder geleert
            // worden sein; dann ruecke auf die erste vor.
            that.setState(function (vorher) {
                return {
                    datadict: gallery.collections,
                    selectedmenu: sichtbar.indexOf(vorher.selectedmenu) >= 0
                        ? vorher.selectedmenu
                        : sichtbar[0] || null
                };
            });
        });
    }

    componentWillUnmount() {
        if (this.unsubscribe) {
            this.unsubscribe();
        }
        if (this.disposeLayout) {
            this.disposeLayout();
        }
        if (this.disposeDevice) {
            this.disposeDevice();
        }
    }

    sichtbareKategorien() {
        return this.state.datadict ? visibleCollectionKeys(this.state.datadict) : [];
    }

    changeContent = (index) => {
        this.setState({
            selectedmenu: index
        });
    };

    // Blaettert zyklisch durch die sichtbaren Kategorien.
    blaettern = (schritt) => {
        var sichtbar = this.sichtbareKategorien();
        if (sichtbar.length === 0) {
            return;
        }
        var aktuell = sichtbar.indexOf(this.state.selectedmenu);
        var naechster = (aktuell + schritt + sichtbar.length) % sichtbar.length;
        this.setState({ selectedmenu: sichtbar[naechster] });
    };

    nextContent = () => {
        this.blaettern(1);
    };

    prevContent = () => {
        this.blaettern(-1);
    };

    render() {
        var that = this;
        if (!this.state.datadict) {
            return <div class='fullwidthcontainer' />;
        }
        var sichtbar = this.sichtbareKategorien();
        var kategorie = this.state.datadict[this.state.selectedmenu];
        if (sichtbar.length === 0 || !kategorie) {
            return (
                <div class='fullwidthcontainer'>
                    <div class='text center fullwidth emptynote'>
                        Zurzeit sind keine Schmuckst&uuml;cke eingestellt.
                    </div>
                </div>
            );
        }

        var submenu;
        if (this.state.mode === 'web') {
            var kacheln = (sichtbar.map(function (item) {
                return <button type='button' class='collections-submenu' key={item} onClick={() => that.changeContent(item)}>
                    <div class="floatrelative fullwidth">
                        <img src={that.state.datadict[item]["mainimage"]} alt="" class='collections-submenu-image center' />
                    </div>
                    <div class='menuitem text center fullwidth'> {that.state.datadict[item]["caption"]}</div> </button>
            }));
            submenu = <div class='collections-submenu-container fullwidthcontainer inlineblock'>
                <div class='collections-submenu-liste'>
                    {kacheln}
                </div>
            </div>
        }
        else {
            submenu = (<div class='collections-submenu-container fullwidthcontainer inlineblock centercontainer'>
                <div class='collections-submenu-navigation'>
                    <button type='button' class='collections-navigation-button' aria-label='Vorherige Kategorie' onClick={() => that.prevContent()}>
                        <img src="./assets/arrow_left.png" alt="" class='collections-navigation-image center' />
                    </button>
                </div>
                <div class='collections-submenu-center'>
                    <img src={kategorie["mainimage"]} alt="" class='collections-submenu-image center' />
                    <div class='collections-navigation-text text center fullwidth'> {kategorie["caption"]}</div>
                </div>
                <div class='collections-submenu-navigation'>
                    <button type='button' class='collections-navigation-button' aria-label='N&auml;chste Kategorie' onClick={() => that.nextContent()}>
                        <img src="./assets/arrow_left.png" alt="" class='collections-navigation-image center rotateimg180' />
                    </button>
                </div>
            </div >)
        }

        var beschriftung = kategorie["caption"];
        // Die ersten beiden Reihen sofort, alles darunter erst beim Scrollen —
        // sonst fordert die Seite alle 36 Ohrringe auf einmal an.
        var list = (kategorie["items"].map(function (item, index) {
            return <img src={item.src} alt={beschriftung} class='smallimage' key={item.src}
                loading={index < 6 ? 'eager' : 'lazy'} decoding='async' />;
        }));

        var collections = (
            <div class="fullwidth">
                {submenu}
                {/* Die Spaltenzahl kommt aus der Datenbank und steuert ueber
                    die CSS-Variable die Breite der Bilder. */}
                <div class="fullwidthcontainer" style={{ '--spalten': kategorie.columns[this.state.geraet] }}>
                    {list}
                </div>
            </div>
        )
        return collections;
    }
}

export default (Collections);
